import React from 'react';
import './InputSuccess.scss';

export default function InputError({message, children})
{
    return (
        <span className='input-success-container'>
            {message ? <span className='input-success'>{children||message}</span> : null}
        </span>
    )
}